<p-confirmDialog key="timegrade" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGrade"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedGrade"
		dataKey="GradeLevelID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="GradeLevelDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--TardyTime-->
				<th></th>

				<!--Update Button-->
				<th></th>
				<!--Clear Button-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="GradeLevelDesc">Grade<p-sortIcon field="GradeLevelDesc"></p-sortIcon></th>
				<th pSortableColumn="TardyTime">Tardy Time<p-sortIcon field="TardyTime"></p-sortIcon></th>
				<th></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Grade>
			<tr [pSelectableRow]="Grade">
				<td
					*ngFor="let col of cols"
					style="font-weight: bold"
					[ngStyle]="{
						color: Grade.TardyTime == '' ? 'Red' : 'Black'
					}"
				>
					{{ Grade[col.field] }}

					<p *ngIf="Grade.TardyTime == ''">(Tardy Time Not Set)</p>
				</td>

				<td>
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						showTime="true"
						hourFormat="12"
						timeOnly="true"
						[(ngModel)]="Grade.TardyTimeDate"
						name="TardyTimeDate"
						appendTo="body"
					></p-calendar>
				</td>

				<td>
					<button class="btn btn-primary" (click)="onUpdate(Grade)">Set Time</button>
				</td>
				<td>
					<button class="btn btn-primary" (click)="onReset(Grade)">Reset Time</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
